"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.renderIcon = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _link = _interopRequireDefault(require("../../utils/link"));

var _styled = require("./styled");

var _propTypes = _interopRequireDefault(require("prop-types"));

var cloneIconWithSize = function cloneIconWithSize(iconNode) {
  return React.cloneElement(iconNode, {
    size: iconNode.props.size || 'normal'
  });
};

var renderIcon = function renderIcon() {
  var icon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var isLeft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!icon) return null;
  return React.createElement(_styled.PaddingWrap, {
    isLeft: isLeft
  }, cloneIconWithSize(icon));
};
/**
 * Ссылки могут содержать текст и иконку рядом с текстом. Если вам нужно использовать Link
 * из React Router, возьмите компонент RouterLink
 */


exports.renderIcon = renderIcon;

var Link = function Link(_ref) {
  var children = _ref.children,
      href = _ref.href,
      leftIcon = _ref.leftIcon,
      rightIcon = _ref.rightIcon,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["children", "href", "leftIcon", "rightIcon"]);
  var LinkComponent = href ? 'a' : 'span';
  return React.createElement(LinkComponent, (0, _extends2["default"])({
    href: href
  }, props), renderIcon(leftIcon, true), children, renderIcon(rightIcon));
};

Link.propTypes = {
  /**
    Чаще всего текст ссылки
  */
  children: _propTypes["default"].node.isRequired,

  /**
    Иконка слева от текста
  */
  leftIcon: function leftIcon() {
    return (typeof React.bpfrpt_proptype_Element === "function" ? React.bpfrpt_proptype_Element : _propTypes["default"].shape(React.bpfrpt_proptype_Element)).apply(this, arguments);
  },

  /**
    Иконка справа от текста
  */
  rightIcon: function rightIcon() {
    return (typeof React.bpfrpt_proptype_Element === "function" ? React.bpfrpt_proptype_Element : _propTypes["default"].shape(React.bpfrpt_proptype_Element)).apply(this, arguments);
  },

  /**
    Адрес ссылки. Если не передан, рендерится <span>
  */
  href: _propTypes["default"].string
};
Link.defaultProps = {
  href: null,
  leftIcon: null,
  rightIcon: null
};
var StyledLink = (0, _styledComponents["default"])(Link).withConfig({
  displayName: "Link__StyledLink",
  componentId: "v4lrj-0"
})(["", " display:inline-flex;align-items:center;"], _link["default"]);
var _default = StyledLink;
exports["default"] = _default;